import angular from 'angular';

const kformSelectItemDirective = /* @ngInject */ (
	/** @type {import('angular').ICompileService} */ $compile,
) => ({
	restrict: 'E',
	scope: {
		template: '=',
		item: '=',
		select: '=',
	},
	/**
	 * @param {any} scope
	 * @param {import('angular').IRootElementService} element
	 */
	link(scope, element) {
		if (scope.options && scope.options.building) {
			return;
		}
		if (scope.template) {
			element.append($compile(angular.element(scope.template))(scope));
		}
	},
});

export default kformSelectItemDirective;
